<template>
    <div>
        <div id="cnCdStock" style="width: 100%;height:calc(100vh - 84px);overflow-x: auto;">
            <div
                style="display: flex; width: 100%; justify-content: space-between; flex-wrap: nowrap;background-color: #fff;">
                <vxe-form v-bind="formOptions" style="flex-wrap: wrap;overflow-x: hidden;  ">
                </vxe-form>
                <vxe-toolbar ref="toolbarRef" custom>
                </vxe-toolbar>
            </div>
            <div style="width: 100%;height:calc(100vh - 188px);overflow-x: auto;">
                <vxe-table id="driverInfo" :data="tableData" border :column-config="{ resizable: true }"
                    class="table-style" :columns="columns" stripe width="100%" height="auto"
                    :custom-config="customConfig" ref="tableRef">
                    <vxe-column type="seq" width="50" align="center"></vxe-column>
                    <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"
                        align="center">
                        <template #default="{ row, column }">
                            <vxe-switch v-if="column.field === 'status'" v-model="row.status"
                                @change="handleSwitchChange(row)">
                            </vxe-switch>
                            <span v-if="column.field !== 'status'"> {{ row[column.field] }} </span>
                        </template>
                    </vxe-column>
                    <vxe-column title="操作" width="250" align="center">
                        <template #default="{ row }">
                            <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                                @click="editEvent(row)">编辑</vxe-button>
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>

            <vxe-pager align="left" :current-page.sync="pageVO.currentPage" :page-size.sync="pageVO.pageSize"
                :total="pageVO.total" @page-change="pageChange">
            </vxe-pager>
            <vxe-modal resize destroy-on-close show-footer show-confirm-button show-cancel-button
                v-model="showEditPopup" :title="selectRow ? '编辑' : '新增'" width="70vw" height="40vh" :loading="loading"
                :confirm-closable="false" @confirm="confirmEvent" @cancel="cancelEvent" @close="cancelEvent">
                <vxe-form ref="formRefDriver" class="form-style" v-bind="formOptionsAdd"></vxe-form>
            </vxe-modal>
        </div>
    </div>
</template>

<script>
import { VxeUI } from 'vxe-pc-ui'
import XEUtils from 'xe-utils'
// 表格自适应
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'address',
    mixins: [userProfile],
    //组件创建
    created() {
        this.loadTableData();
    },
    data() {
        const pageVO = {
            currentPage: 1,
            pageSize: 30,
            total: 20
        }
        const formOptionsAdd = {
            titleWidth: 50,
            titleAlign: 'right',
            titleColon: true,
            data: {
                id: '',
                address: '',
                contactMan: '',
                note: '',
                phone:''
            },
            rules: {
                contactMan: [
                    { required: true, message: '请输入联系人' },
                ],
                phone: [
                    { required: true, message: '请输入电话号码' }
                ],
                address: [
                    { required: true, message: '请输入地址' }
                ],
                note: [
                    { required: true, message: '请输入备注' }
                ],
            },
            items: [
                { field: 'address', title: '地址', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'contactMan', title: '联系人', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'phone', title: '联系电话', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'note', title: '备注', span: 24, itemRender: { name: 'VxeInput' } },
                // {
                //     span: 3,
                //     // collapseNode: true,
                //     align: 'center',
                //     // itemRender: {
                //     //     name: 'VxeButtonGroup',
                //     //     options: [
                //     //         { type: 'submit', content: '搜索', status: 'primary' },
                //     //         { type: 'reset', content: '重置' }
                //     //     ]
                //     // }
                // }
            ]
        }
        const formOptions = {
            data: {
                address: '',
                contactMan: '',
                phone: '',
                note: ''
            },
            items: [
                { field: 'address', title: '地址查询', span: 5, itemRender: { name: 'VxeInput' } },
                { field: 'contactMan', title: '联系人', span: 5, itemRender: { name: 'VxeInput' } },
                { field: 'phone', title: '联系电话', span: 5, itemRender: { name: 'VxeInput' } },
                { field: 'note', title: '备注', span: 5, itemRender: { name: 'VxeInput' } },
                {
                    span: 4,
                    // collapseNode: true,
                    align: 'center',
                    itemRender: {
                        name: 'VxeButtonGroup',
                        options: [
                            // { type: 'submit', content: '获取库存', status: 'info', name: 'getInventory', style: 'min-width: 80px' },
                            // { type: 'submit', content: '获取出库', status: 'warning', name: 'acquireInventory', style: 'min-width: 80px' },

                            { type: 'submit', content: '搜索', status: 'primary', name: 'search', style: 'min-width: 80px' },
                            { type: 'reset', content: '重置', name: 'reset', style: 'min-width: 80px' },
                            { type: 'submit', content: '添加', status: 'success', name: 'obtainInventory', style: 'min-width: 80px' },
                        ],
                        events: {
                            click: this.handleButtonClick // 调用 methods 中的方法
                        }
                    }
                }
            ]
        }
        return {
            pageVO,
            tableData: [],
            columns: [],
            formOptions,
            formOptionsAdd,
            showEditPopup: false,
            loading: false,
            selectRow: undefined,
            isAddEdit: null,
        }
    },
    methods: {
        handleButtonClick(options, button) {
            switch (button.name) {
                case 'search':
                    this.loadTableData();
                    break;
                case 'reset':
                    this.resetEvent();
                    break;
                case 'getInventory':
                    this.getInventory();
                    break;
                case 'acquireInventory':
                    this.acquireInventory();
                    break;
                case 'obtainInventory':
                    this.obtainInventory();
                    break;
            }
        },
        obtainInventory() {
            //判断新增
            this.isAddEdit = 1;
            this.showEditPopup = true;
            this.selectRow = undefined;


        },
        editEvent(row) {
            this.isAddEdit = 2;
            this.showEditPopup = true;
            this.selectRow = row;
            this.formOptionsAdd.data = XEUtils.clone(row, true)
        },
        cancelEvent() {
            this.showEditPopup = false;
            this.formOptionsAdd.data.address = '';
            this.formOptionsAdd.data.phone = '';
            this.formOptionsAdd.data.contactMan = '';
            this.formOptionsAdd.data.note = '';
            this.formOptionsAdd.data.id = '';

        },
        async confirmEvent() {
            const $form = this.$refs.formRefDriver
            if ($form) {
                const errMap = await $form.validate()
                if (!errMap) {
                    this.showEditPopup = false
                    if (this.isAddEdit == 1) {
                        //   新增
                        delete this.formOptionsAdd.data.id;
                    }
                    this.$api.insOrUpdatePort( this.formOptionsAdd.data).then(res =>{
                        VxeUI.modal.message({ content:  this.isAddEdit === 1 ?'新增成功':'编辑成功', status: 'success' })
                        this.loadTableData();
                        this.cancelEvent();
                    })
                }
            }
        },
        // 重置
        resetEvent() {
            this.formOptions.data.phone = '';
            this.formOptions.data.contactMan = '';
            this.formOptions.data.note = '';
            this.formOptions.data.address = '';
        },
        pageChange({ pageSize, currentPage }) {
            this.pageVO.currentPage = currentPage
            this.pageVO.pageSize = pageSize
            this.loadTableData()
        },
        // 加载表格数据和列配置
        loadTableData() {
            this.$api.getPortsBy( this.pageVO.currentPage, this.pageVO.pageSize, this.formOptions.data).then(res =>{
                this.columns = res.columns; // 动态列配置
                this.tableData = res.tableData; // 表格数据
                this.pageVO.total = res.total;
            })
        },
    }
}
</script>

<style lang="css" scoped>
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .form-style .vxe-form--item-title {
    width: 120px !important;
}

::v-deep .vxe-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 60px;
    /* padding:0 2px !important; */
}

::v-deep .vxe-form--wrapper {
    flex: 1;
    width: 100%;
    flex-wrap: wrap !important;

}
</style>